import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { ApiCollection } from '../providers/api-collection';

@Injectable({
  providedIn: 'root'
})
export class EventModeratorsService {

  constructor(private apiService: ApiService) {}

  getModerators(eventId: number): Observable<any> {
    const url = `${this.apiService.url}${ApiCollection.EventModerators}?event=${eventId}&page_size=100`;
    return this.apiService
      .execute({}, url, 'GET')
      .pipe(map((res: any) => res.res));
  }

  getAllModerators(page: number = 1, pageSize: number = 200, search: string = ''): Observable<any> {
    let action = `${ApiCollection.EventModerators}?page=${page}&page_size=${pageSize}`;
    if (search?.trim()) {
      action += `&search=${encodeURIComponent(search.trim())}`;
    }

    return this.apiService
      .execute({}, `${this.apiService.url}${action}`, 'GET')
      .pipe(map((res: any) => res.res));
  }

  getModeratorById(id: number): Observable<any> {
    const url = `${this.apiService.url}${ApiCollection.EventModerators}/${id}`;
    return this.apiService
      .execute({}, url, 'GET')
      .pipe(map((res: any) => res.res));
  }

  createModerator(payload: {
    name: string;
    company?: string;
    job_title?: string;
    email?: string;
    phone_number?: string;
    linkedin_url?: string;
    created_by: number;
  }): Observable<any> {
    const url = `${this.apiService.url}${ApiCollection.EventModerators}`;
    return this.apiService
      .execute(payload, url, 'POST')
      .pipe(map((res: any) => res.res));
  }

  updateModerator(id: number, payload: any): Observable<any> {
    const url = `${this.apiService.url}${ApiCollection.EventModerators}/${id}`;
    return this.apiService
      .execute(payload, url, 'PATCH')
      .pipe(map((res: any) => res.res));
  }

  deleteModerator(id: number): Observable<any> {
    const url = `${this.apiService.url}${ApiCollection.EventModerators}/${id}`;
    return this.apiService
      .execute({}, url, 'DELETE')
      .pipe(map((res: any) => res.res));
  }

  updateEventModerators(eventId: number, moderatorIds: number[], modifiedBy: number): Observable<any> {
    const url = `${this.apiService.url}${ApiCollection.Event}/${eventId}`;
    return this.apiService
      .execute({ event_moderators: moderatorIds, modified_by: modifiedBy }, url, 'PATCH')
      .pipe(map((res: any) => res.res));
  }
}
